module.exports = __webpack_public_path__ + "static/media/search.1a28e885.svg";